var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-solid:store",
    clipPath: "url(#clip0_2804_920)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3589 3.06536L11.0657 1.01832C10.9506 0.835503 10.7452 0.722656 10.5263 0.722656H2.47351C2.25458 0.722656 2.0492 0.835503 1.9341 1.01832L0.638611 3.06536C-0.0294445 4.12161 0.561875 5.59089 1.80997 5.76016C1.90024 5.77144 1.99278 5.77821 2.08306 5.77821C2.67212 5.77821 3.19573 5.52092 3.55458 5.1237C3.91344 5.52092 4.43705 5.77821 5.02611 5.77821C5.61517 5.77821 6.13878 5.52092 6.49764 5.1237C6.85649 5.52092 7.3801 5.77821 7.96917 5.77821C8.56049 5.77821 9.08184 5.52092 9.44069 5.1237C9.80181 5.52092 10.3232 5.77821 10.9122 5.77821C11.0048 5.77821 11.095 5.77144 11.1853 5.76016C12.4379 5.59314 13.0315 4.12387 12.3612 3.06536H12.3589ZM11.2778 6.47561H11.2756C11.156 6.49141 11.0341 6.50043 10.91 6.50043C10.6301 6.50043 10.3615 6.45755 10.111 6.38082V9.38932H2.88878V6.37856C2.63601 6.45755 2.36517 6.50043 2.08531 6.50043C1.96118 6.50043 1.83705 6.49141 1.71743 6.47561H1.71517C1.62264 6.46207 1.53236 6.44627 1.44434 6.4237V10.8338C1.44434 11.6305 2.09208 12.2782 2.88878 12.2782H10.111C10.9077 12.2782 11.5555 11.6305 11.5555 10.8338V6.4237C11.4652 6.44627 11.3749 6.46432 11.2778 6.47561Z",
    fill: "#5881FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2804_920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 11.5556,
    fill: "white",
    transform: "translate(0 0.722656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.3eefa85d57597b5ff41a6036129e4228.svg";
export { ForwardRef as ReactComponent };